import { graphql, useStaticQuery } from 'gatsby';

//DOC: types can be an array of => limited/discontinued/plug
const useProductMarkingHook = (types) => {
  const markingData = useStaticQuery(
    graphql`
      query {
        allSanityProductMarking {
          edges {
            node {
              position
              _id
              width
              height
              image {
                asset {
                  url
                }
              }
              title
            }
          }
        }
      }
    `,
  );

  const markingArray = markingData.allSanityProductMarking.edges;
  

  return markingArray.reduce((acc, marking, index) => {
    if (types.includes(marking.node._id))
      acc.push({
        img: marking.node.image.asset.url,
        pos: marking.node.position,
        h: marking.node.height ?? 'auto',
        w: marking.node.width ?? 'auto'
      })
  
    return acc;
  }, []);
};

export default useProductMarkingHook;
